export default __webpack_public_path__ + "static/media/extend-span.6c1d19e8.gif";